import { http } from '@/lib/ats-https';
import { http as oldHttp } from '@/lib/http';
// Survey APIs
const getSurveyList = async (params?: Record<string, any>) => {
  const response = await http.get('/survey_form_templates', {
    params,
  });
  return response;
};

const getSurveyById = async (
  surveyId: string | number,
  params?: Record<string, any>
) => {
  const response = await http.get(`/survey_form_templates/${surveyId}`, {
    params,
  });

  return response;
};

const createSurvey = async (payload: any) => {
  const response = await http.post('/survey_form_templates', payload);

  return response;
};

const deleteSurvey = async (surveyId: string | number) => {
  const response = await http.delete(`/survey_form_templates/${surveyId}`);

  // Check for errors in API response
  if (response.data?.errors && response.data.errors.length > 0) {
    throw new Error(response.data.errors[0] || 'Failed to delete survey');
  }

  return response.data;
};

// Survey Question APIs
const surveyQuestionsCrud = async ({
  surveyId,
  payload,
}: {
  surveyId: string | number;
  payload: any;
}) => {
  const response = await http.put(
    `/survey_form_templates/${surveyId}`,
    payload
  );

  return response;
};

const deleteSurveyQuestion = async ({
  surveyId,
  questionId,
}: {
  surveyId: string | number;
  questionId: string | number;
}) => {
  const response = await http.delete(
    `/survey_form_templates/${surveyId}/fields/${questionId}`
  );

  // Check for errors in API response
  if (response.data?.errors && response.data.errors.length > 0) {
    throw new Error(response.data.errors[0] || 'Failed to delete question');
  }

  return response.data;
};

const cloneSurvey = async ({ surveyId }: { surveyId: string | number }) => {
  const response = await http.post(`/survey_form_templates/${surveyId}/clone`);
  return response;
};

const deleteSurveySection = async ({
  surveyId,
  sectionId,
}: {
  surveyId: string | number;
  sectionId: string | number;
}) => {
  const response: any = await http.delete(
    `/survey_form_templates/${surveyId}/sections/${sectionId}`
  );

  // Check for errors in API response
  if (response?.errors && response.errors.length > 0) {
    throw new Error(response.errors[0] || 'Failed to delete section');
  }

  return response;
};

const unpublishSurvey = async ({ surveyId }: { surveyId: string | number }) => {
  const response = await http.patch(
    `/survey_form_templates/${surveyId}/update_status`,
    {
      status: 'inactive',
    }
  );
  return response;
};

const publishSurvey = async ({ surveyId }: { surveyId: string | number }) => {
  const response = await http.patch(
    `/survey_form_templates/${surveyId}/update_status`,
    {
      status: 'published',
    }
  );
  return response;
};

const getSurveySubmissions = async ({
  surveyId,
  params,
}: {
  surveyId: string | number;
  params?: Record<string, any>;
}) => {
  const response = await http.get(
    `/survey_form_templates/${surveyId}/submissions`,
    {
      params,
    }
  );
  return response;
};

const getSurveySubmissionResponse = async ({
  surveyId,
  submissionId,
  ats_job_id,
  ats_form_template_id,
}: {
  surveyId: string | number;
  submissionId: string | number;
  ats_job_id?: string | number;
  ats_form_template_id?: string | number;
}) => {
  const params: Record<string, string | number> = {};
  if (ats_job_id) params.ats_job_id = ats_job_id;
  if (ats_form_template_id) params.ats_form_template_id = ats_form_template_id;

  const response = await http.get(
    `/ats_surveys/${surveyId}/submissions/${submissionId}`,
    { params: Object.keys(params).length > 0 ? params : undefined }
  );
  return response;
};

const deleteSurveySubmission = async ({
  surveyId,
  submissionId,
}: {
  surveyId: string | number;
  submissionId: string | number;
}) => {
  const response = await http.delete(
    `/ats_surveys/${surveyId}/submissions/${submissionId}`
  );
  return response;
};

const getSurveySummary = async ({
  surveyId,
  params,
}: {
  surveyId: string | number;
  params?: Record<string, any>;
}) => {
  const response = await http.get(
    `/survey_form_templates/${surveyId}/submissions/summary`,
    {
      params,
    }
  );
  return response;
};

const sendSurveyReminder = async ({ payload }: { payload: any }) => {
  const response = await http.post(
    `/ats_survey_reminders/send_reminder`,
    payload
  );
  return response;
};

const exportSurvey = async ({ survey_id, ...params }) => {
  const response = await http.post(
    `/survey_form_templates/${survey_id}/submissions/export`,
    { ...params }
  );
  return response;
};

const getBrandingTheme = async () => {
  const response = await oldHttp.get(`account/theme`);
  return response;
};

export const SURVEY_API_SERVICES = {
  getSurveyList,
  getSurveyById,
  createSurvey,
  deleteSurvey,
  cloneSurvey,
  surveyQuestionsCrud,
  deleteSurveyQuestion,
  deleteSurveySection,
  unpublishSurvey,
  publishSurvey,
  getSurveySubmissions,
  getSurveySubmissionResponse,
  getSurveySummary,
  deleteSurveySubmission,
  sendSurveyReminder,
  getBrandingTheme,
};

export const EXPORT_SURVEY_API_SERVICE = {
  exportSurvey,
};
